import {format, parseISO} from 'date-fns';
import {BillData, SaoLucasBillItem} from 'domain/usecases';
import {BillStatusEnum} from 'presentation/constants';

export const mapSaoLucasBillToBillData = (item: SaoLucasBillItem): BillData => {
	const dtVencimento = format(parseISO(item.vencimento), 'dd/MM/yyyy');
	const status = item.status === 'À Vencer' ? BillStatusEnum.OPEN : BillStatusEnum.EXPIRED;
	const uniqueId = parseISO(item.vencimento).getTime();

	return {
		dtPrevista: dtVencimento,
		cdObrigacao: uniqueId,
		cdObrigacaoOrigem: uniqueId,
		status,
		flTipoPdf: false,
		flMigracao: false,
		linhaDigitavel: {
			vlObrigacao: String(item.valor),
			dtVencimento: dtVencimento,
			cdBarra: item.linhaDigitavel,
		},
		cdEspecieTitulo: 0,
	};
};
